import { DefaultLoadingManager, EquirectangularReflectionMapping, LoadingManager, PMREMGenerator, Scene, Texture, WebGLRenderer } from "three";
import { HDRLoader } from "three/examples/jsm/loaders/HDRLoader";
import assets from "../assets";

export class UpdateSceneEnvironment {
    manager: LoadingManager;
    loader: HDRLoader;
    generator: PMREMGenerator;

    constructor(renderer: WebGLRenderer, manager?: LoadingManager) {
        this.manager = manager ?? DefaultLoadingManager;
        this.loader = new HDRLoader(this.manager);
        this.generator = new PMREMGenerator(renderer);
        this.generator.compileEquirectangularShader();
    }

    update = (scene: Scene, assetId: string) => {
        scene.userData.cpsEnvironmentAssetId = assetId;
        this.loader.loadAsync(assets.resolve(assetId, 'HDR'))
            .then((hdr: Texture) => {
                hdr.mapping = EquirectangularReflectionMapping;
                hdr.needsUpdate = true;
                
                const pmrem = this.generator.fromEquirectangular(hdr).texture;
                scene.environment = pmrem;
            })
            .catch(console.error);
    }
};
export default UpdateSceneEnvironment;
